// 引入api
import { fun_PostAction, fun_Download } from "@/api";
//引入下载方法
import { fun_DownloadFile } from "@/utils/validate.js";
// 默认导出
export default {
    // 数据存储对象
    data: () => {
        return {
            /*************************公告信息***************************/
            guid: null, // 主键
            invitationBids:true, // 收起 展开 招标概况
            purchasers:true, // 收起 展开 采购人与采购代理
            detailedAnnouncement:true, // 收起 展开 详细公告内容
            file:true, // 收起 展开 附件信息
            // 项目信息
            detail: {
                /********************* 招标概况 *********************/
                guid: null, // 主键
                title: null, // 标题
                bianhao: null, // 工程编号
                xmlb: null, // 项目类型
                zbxmmc: null, // 招标项目名称
                zbxmzj: null, // 招标项目主键
                tzxmtydm: null, // 投资项目统一代码
                xmczbl: null, // 项目出资比例
                xmbajg: null, // 项目备案机关
                xmgm: null, // 项目规模
                gclb: null, // 工程类别
                gclx: null, // 工程类型
                zbfs: null, // 招标方式
                zgscfs: null, // 资格审查方式
                zbwjzgyswjhqfs: null, // 招标文件/资格预审文件获取方式
                jydd: null, // 交易地点
                ggxz: null, // 公告性质
                tbwjdjdd: null, // 投标文件递交地点
                tsfbggmtmc: null, // 同时发布公告的媒体名称
                ggfbksjs: null, // 公告发布开始时间
                ggfbjssj: null, // 公告发布结束时间
                ggzyjzsj: null, // 公告质疑截止时间
                ggdyjzsj: null, // 公告答疑截止时间
                bz: null, // 备注
                /********************* 招标人与招标代理 *********************/
                jsdw: null, // 建设单位
                zbrZjjgdm: null, // 组织机构代码（招标人）
                zbrJbr: null, // 经办人（招标人）
                zbrBgdh: null, // 办公电话（招标人）
                zbrYddh: null, // 移动电话（招标人
                zbdljg: null, // 招标代理机构
                zbdlZjjgdm: null, // 组织机构代码（招标代理）
                zbdlJbr: null, // 经办人（招标代理）
                zbdlBgdh: null, // 办公电话（招标代理）
                zbdlYddh: null // 移动电话（招标代理）
            },
            /********************* 详细公告内容 *********************/
            // 列表数据
            bdTableData: [],
            /************************ 附件信息 **************************/
            // 列表loading状态
            fileTableColumns: [
                {
                label: "文件名",
                prop: "ymWjm"
                },
                {
                label: "创建时间",
                prop: "ymCjsj"
                },
            ],
            fileTableData: [],
        };
    },

    mounted() {
        // 获取主键
        this.guid = this.$route.query.guid;
        // 获取公告详情
        this.fun_GetDetail();
        // 获取标段一览
        this.fun_GetBdList();
        // 货物文件下载一览数据
        this.fun_GetFileDownloadConnectionList()
    },
    // 自定义事件
    methods: {
        /***********************************公告信息**************************************/
        /**
         * 获取公告信息
         */
        fun_GetDetail() {
            // 请求
            fun_PostAction("/hiConstruction/biddingNoticeDetail", {
                guid: this.guid // 主键
            }).then(res => {
                // 解构res.data
                const { result, data, msg } = res.data;
                // 解析后台返回的结果集，判断是否成功
                if (result) {
                    // 成功的场景
                    this.detail = data;
                } else {
                    // 请求失败的场景
                    // 请求失败，弹出失败msg的消息提示
                    this.$message.error(msg);
                }
            });
        },
        /**
         * 获取标段一览数据
         * @author 滕威
         */
        fun_GetBdList() {
            try {
                // 执行获取列表接口
                fun_PostAction("/hiConstruction/biddingNoticeBdList", {
                    pidGuid: this.guid // 父亲主键
                }).then(res => {
                    console.log(res.data);
                    // 解构res.data
                    const { result, data, msg } = res.data;
                    // 解析后台返回的结果集，判断是否成功
                    if (result) {
                        // 成功的场景
                        // 将请求到的table数据渲染到table
                        this.bdTableData = data;
                    } else {
                        // 请求失败的场景
                        // 请求失败，弹出失败msg的消息提示
                        this.$message.error(msg);
                    }
                    // 关闭loading
                    this.loading = false;
                });
            } catch {
                // 关闭loading
                this.loading = false;
            }
        },
         /**
         * 获取文件下载一览数据
         * @author 滕威
         */
        fun_GetFileDownloadConnectionList() {
            // 执行获取列表接口
            fun_PostAction("/hiProcurement/fileDownloadConnectionList", {
            pidGuid: this.guid, // 父亲主键
            djglidGuid: this.guid, // 父亲主键
            }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
                // 成功的场景
                // 将请求到的table数据渲染到table
                this.fileTableData = data;
            } else {
                // 请求失败的场景
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
            }
            });
        },
        /**
         * 下载
         * @author 滕威
         */
        fun_DownloadFiles(filePath) {
            if (filePath) {
            const form = {
                filePath: filePath
            };
            // 下载文件
            fun_Download("/downloadLocal", form).then(res => {
                // 获取头部
                let fileNames = res.headers["content-disposition"]; //获取到Content-Disposition;
                if (fileNames) {
                let regFileNames = fileNames.match(/=(.*)$/)[1];
                // 调用下载文件公共方法
                fun_DownloadFile(res, decodeURIComponent(regFileNames));
                } else {
                fun_DownloadFile(res, Math.random() + ".pdf");
                }
            });
            } else {
            this.$message.error("文件不存在！");
            }
        },
    }
};
